import { getMediaTypeByExtension, getFileExtension } from '../../../utils/extensions';
import { MediaType } from '../../../constants/MediaType';
import { ItemKind } from '../../../constants/ItemKind';
var MEDIA_TYPES_WITH_THUMBNAILS = [MediaType.Video, MediaType.Picture];

var hasThumbnail = function hasThumbnail(extension) {
  return ['pdf', 'rtf'].indexOf(extension) >= 0 || MEDIA_TYPES_WITH_THUMBNAILS.indexOf(getMediaTypeByExtension(extension)) >= 0;
};

var encodePath = function encodePath(uriComponent) {
  return encodeURIComponent(uriComponent).replace("'", '%27');
};

export var toItem = function toItem(data, settings) {
  var fileExtension = getFileExtension(data);
  var mediaType = getMediaTypeByExtension(fileExtension);
  var encodedPath = encodePath(data.path_lower);
  var item = {
    id: data.id,
    name: data.name,
    kind: ItemKind.File,
    source: 'dropbox',
    mediaType: mediaType,
    fileUrl: data.url,
    thumbnailUrl: "" + settings.apiUrl + settings.apiPath + "/thumbnail?path=" + encodedPath,
    createdAt: data.client_modified,
    tags: []
  };

  if (hasThumbnail(fileExtension)) {
    item.previewUrl = "" + settings.apiUrl + settings.apiPath + "/thumbnail?path=" + encodedPath + "&size=w640h480";
  }

  return item;
};